@if (loadStatus() === 'failed') {
  <glxy-alert
    class="knowledge-error"
    type="error"
    [showAction]="true"
    actionTitle="{{ 'COMMON.RETRY' | translate }}"
    (actionClick)="initialize()"
  >
    {{ 'ERROR_LOADING_KNOWLEDGE' | translate }}
  </glxy-alert>
} @else if (loadStatus() === 'loading') {
  <glxy-loading-spinner></glxy-loading-spinner>
} @else {
  <ai-knowledge-knowledge-list
    [knowledgeSources]="selectedSources()?.sources ?? []"
    [knowledgeBases]="selectedKnowledgeBases()"
    [allowRemoveBusinessProfile]="true"
    [editingEnabled]="enabled()"
    (refreshList)="refreshSources()"
    (titleClicked)="viewSource($event)"
    (removeClicked)="removeSource($event)"
    (knowledgeBaseRemoveClicked)="removeKnowledgeBase($event)"
  >
  </ai-knowledge-knowledge-list>
  <glxy-form-field class="knowledge-select">
    <input
      #knowledgeSourceInput
      matInput
      #trigger="matAutocompleteTrigger"
      placeholder="{{ 'ADD_KNOWLEDGE' | translate }}"
      [formControl]="selectedSourceControl"
      autocomplete="off"
      (keydown.enter)="chooseMatch($event)"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onKnowledgeOptionSelected($event.option.value)">
      <mat-option class="source-option">
        <a matLine>
          {{ 'ADD_NEW_KNOWLEDGE' | translate }}
        </a>
      </mat-option>
      @if (filteredSources().length > 0 || filteredKnowledgeBases().length > 0) {
        <mat-divider></mat-divider>
      }
      @for (source of filteredSources(); track source) {
        <mat-option [value]="{ kind: 'source', source }" class="source-option">
          <mat-icon class="knowledge-option-icon">{{ getKnowledgeSourceIcon(source) }}</mat-icon>
          <div matLine>
            {{ source.name }}
            @if (source.isSuggested) {
              <glxy-badge [size]="'small'">{{ 'SUGGESTED' | translate }}</glxy-badge>
            }
          </div>
          <div matLine class="source-preview">{{ getKnowledgePreview(source) }}</div>
        </mat-option>
      }
      @for (kb of filteredKnowledgeBases(); track kb.id) {
        <mat-option [value]="{ kind: 'base', base: kb }" class="source-option">
          <mat-icon class="knowledge-option-icon">library_books</mat-icon>
          <div matLine>{{ kb.name }}</div>
          @if (kb.description) {
            <div matLine class="source-preview">{{ kb.description }}</div>
          }
        </mat-option>
      }
    </mat-autocomplete>
  </glxy-form-field>
}
